import React from 'react'
import { FaChartArea } from 'react-icons/fa6'

function Title({ title, icon: Icon }) {
    // const Icon = icon;
    return (
        <div className='flex justify-normal items-center mb-6'>
            <Icon className='text-2xl text-primary' />
            {/* {icon} */}
            <h3 className='text-2xl ml-5'>{title}</h3>
        </div>
    )
}

export default Title